import React, { useContext } from "react";
import { LoaderWrapper, ManageMastersLayout } from "../../../components";
import GenericTable from "./GenericTable";
import { manageMasterStore } from "../../../contexts";
import { useRequest } from "../../../abstracts";
import { GetTradingPartnerList } from "../../../services";
import { isEmpty, get } from "lodash";

const ClearingPartnerContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);
  const { response: clearingPartnerList, loading } = useRequest({
    method: GetTradingPartnerList,
    defaultResponse: [],
  });
  console.log("clearingPartnerList", clearingPartnerList);
  return (
    <ManageMastersLayout layoutHeader="Clearing Partner">
      <LoaderWrapper loading={loading}>
        <div className="clearing-partner-container">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {clearingPartnerList.length} Records found
            </div>
          </div>
          <div className="clearing-partner-list-container">
            {!isEmpty(clearingPartnerList) && (
              <GenericTable
                state={state}
                dispatch={dispatch}
                clearingPartnerList={clearingPartnerList}
              />
            )}
          </div>
        </div>
      </LoaderWrapper>
    </ManageMastersLayout>
  );
};

export default ClearingPartnerContainer;
